import { Helmet } from "react-helmet-async";
import OasisAdsForm from "@/components/OasisAdsForm";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function OasisAds() {
  return (
    <>
      <Helmet>
        <title>Google Ads Intake Form - Oasis Recovery Center | Mosheli</title>
        <meta name="description" content="Complete our Google Ads intake form to help us create an effective advertising campaign for your addiction treatment facility." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-1 py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <OasisAdsForm />
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}
